import BaseStore from '@src/utils/store/base-store';
import useMount from '@src/utils/hooks/use-mount';
import InnerWrapStore from '@src/pages/inner-wrap/store';
import { computed, observable } from 'mobx';
import { useEffect } from 'react';
import { getParameterByNames } from '@src/utils/device';
import { getOmniData, strategy, geyOmniSearch } from '@src/services/omni-api';
import createHtmlLink from '@src/utils/create-html-link';
import buildRouteUrl from '@src/utils/build-route-url';
import $$tracker from '@src/tracker';

class StrategyListStore extends BaseStore {
  @observable keyword = '';
  innerWrapStore = new InnerWrapStore({
    title: '攻略资料',
    breadcrumb: [
      {
        title: '攻略资料',
        link: ''
      },
      {
        title: '最新',
        link: ''
      }
    ],
    current: 4,
    type: 'strategy-list'
  });
  @observable tabList = strategy;
  @observable currentTab = 1;
  @observable currentPage = 1;
  @observable pageSize = 10;
  @observable total = 0;
  @observable pageInput = '';
  @observable strategyList = [];
  @observable allData = {};
  @observable searchData = {};

  @computed
  get showTotal() {
    return `共 ${Math.ceil(this.total / this.pageSize)} 页`;
  }

  setCurrentTab = currentTab => {
    if (this.currentTab === currentTab) {
      return;
    }
    this.currentTab = currentTab;
    this.currentPage = 1;
    if (this.keyword) {
      this.search();
    } else {
      this.getStrategyList(this.currentTab);
    }

    const url = window.location.href;
    const categoryId = getParameterByNames('categoryId');
    const newUrl = url.replace(`categoryId=${categoryId}`, `categoryId=${currentTab}`);
    window.history.pushState({}, '', newUrl);
  };

  setKeyword = keyword => {
    this.keyword = keyword;
  };

  setPageInput = value => {
    this.pageInput = value;
  };

  changeCurrentPage = page => {
    if (page) {
      this.currentPage = page;
      // TODO 请求翻页
      if (this.keyword) {
        this.search();
      } else {
        this.getStrategyList(this.currentTab);
      }
    } else {
      // 判断this.pageInput是否为一个正整数
      if (this.pageInput && /^\d+$/.test(this.pageInput)) {
        // 判断 Number(this.pageInput) 是否大于总页数
        if (Number(this.pageInput) > Math.ceil(this.total / this.pageSize)) {
          this.currentPage = Math.ceil(this.total / this.pageSize);
        } else {
          this.currentPage = Number(this.pageInput);
        }
        // TODO 请求翻页
        this.pageInput = '';
        if (this.keyword) {
          this.search();
        } else {
          this.getStrategyList(this.currentTab);
        }
      } else {
        this.pageInput = '';
      }
    }
  };

  initBreadcrumb = () => {
    const breadcrumb = [
      {
        title: '攻略资料',
        link: '/?currentPage=4'
      }
    ];
    const categoryId = getParameterByNames('categoryId');
    if (categoryId) {
      const currentNews = strategy[categoryId] || '';
      breadcrumb.push({
        title: currentNews?.title || '',
        link: ''
      });
      this.currentTab = categoryId;
      this.innerWrapStore.breadcrumb = breadcrumb;
    }
  };

  getStrategyList = async categoryId => {
    try {
      let dataSources = [];
      if (categoryId) {
        dataSources.push({
          dataSourceId: categoryId || '',
          page: this.currentPage,
          perPage: this.pageSize
        });
      } else {
        dataSources = Object.keys(this.tabList).map(tab => {
          return {
            dataSourceId: tab || '',
            page: this.currentPage,
            perPage: this.pageSize
          };
        });
      }
      const res = await getOmniData('channel_cat_881beee2', dataSources);
      if (categoryId) {
        this.allData[categoryId] = res[categoryId];
      } else {
        this.allData = res;
      }
      this.setCurrentData();
    } catch (error) {
      console.log(error);
    }
  };

  setCurrentData = type => {
    const categoryId = this.currentTab;
    const data = type === 'search' ? this.searchData : this.allData[categoryId]?.result || {};
    if (data?.items) {
      const spliceData = data.items || [];
      this.strategyList = spliceData;
      this.total = data.total || 0;
    } else {
      this.strategyList = [];
      this.total = 0;
    }
  };

  gotoDetail = item => {
    if (item.jump_link === 'stay') {
      return;
    }
    const categoryId = getParameterByNames('categoryId');
    let url = '';
    if (item.jump_link === 'link') {
      url = item.art_link.url;
    } else {
      // hash 路由: 参数必须拼在 #/strategy-detail 之后, 否则前端路由取不到
      url = buildRouteUrl('/strategy-detail', {
        contentId: item.contentId,
        categoryId,
        page: this.currentPage
      });
    }
    const link = createHtmlLink(url);
    link.target = '_blank';
    link.click();
  };

  search = async () => {
    $$tracker.clickSearchGlzl();
    if (!this.keyword) {
      this.getStrategyList(this.currentTab);
      return;
    }
    try {
      const res = await geyOmniSearch({
        keywords: this.keyword,
        categoryId: this.tabList[this.currentTab].categoryId,
        page: this.currentPage,
        pageSize: this.pageSize
      });
      this.searchData = res || {};
      this.setCurrentData('search');
    } catch (error) {
      console.log(error);
    }
  };

  use() {
    super.use();
    useMount(async () => {
      this.initBreadcrumb();
      this.getStrategyList();
    });

    // 监听分页器DOM变化，更新title
    useEffect(() => {
      const updateTitles = () => {
        const jumpPrevBtn = document.querySelector('.ant-pagination-jump-prev');
        if (jumpPrevBtn) {
          jumpPrevBtn.setAttribute('title', '向前5页');
        }

        const jumpNextBtn = document.querySelector('.ant-pagination-jump-next');
        if (jumpNextBtn) {
          jumpNextBtn.setAttribute('title', '向后5页');
        }
      };
      // 初始设置
      updateTitles();
      // 监听DOM变化，确保分页器动态渲染后title仍然正确
      const observer = new MutationObserver(updateTitles);
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
      return () => observer.disconnect();
    }, []);
  }
}

export default StrategyListStore;
